import { loadIcons } from '@iconify/react'

import dataSet from '../preload-icons.json' with { type: 'json' }

export function preloadIcons() {
  loadIcons(dataSet.icons, (loaded, missing, pending) => {
    if (loaded.length) {
      console.log(`${loaded.length} icons have been loaded and are ready to be renderered.`)
      return
    }

    if (missing.length) {
      console.warn(`Icons does not exist.`, missing)
      return
    }

    if (pending.length) {
      // Pending icons list in this example is empty.
      // If you call loadIcons() with multiple icons, pending list might not be empty, but for one icon it is always empty.
      //
      // Callback is called when something changes, with 1 icon there can only be 2 type of changes: icon has loaded or icon is missing.
    }
  })
}
